import { render, staticRenderFns } from "./LoginUser.vue?vue&type=template&id=fa938f1c&scoped=true"
import script from "./LoginUser.vue?vue&type=script&lang=js"
export * from "./LoginUser.vue?vue&type=script&lang=js"
import style0 from "./LoginUser.vue?vue&type=style&index=0&id=fa938f1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa938f1c",
  null
  
)

export default component.exports